/// <reference path="~/js/global.js"/>
/// <reference path="~/js/viz/bar/lib/highcharts.src.js"/>

(function() {
  "use strict";

  var ns;

  ns = window.nspace("ccc.viz.bar.config");

  ns.Config = {
    dataUrl: "/api/BarData/GetBarData",
    /**
     * Default highcharts configuration object. Note: changing font sizes, weights, etc. change app calculations,
     * so modifier beware.
     */
    defaultHighchartsConfig: {
      chart: {
        type: "bar",
        marginRight: 210
      },
      colors: [
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#7ACCD6"], [1, "#41b6c4"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#858EC3"], [1, "#515da9"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#BDE5CA"], [1, "#a1dab4"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#4DACDB"], [1, "#0089cc"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#C2C6E1"], [1, "#a8aed4"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#95D268"], [1, "#68be27"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#B8B8B8"], [1, "#999999"]]
        },
        {
          linearGradient: { x1: 0, x2: 1, y0: 0, y1: 0 },
          stops: [[0, "#C0E1EA"], [1, "#a5d4e1"]]
        }
      ],
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      yAxis: {
        opposite: true,
        title: {
          text: null
        },
        gridLineWidth: 0,
        labels: {
          style: {
            "font-family":
              "GestaCond-Bold, 'GestaCond-Bold', Tahoma, Arial, sans-serif;",
            "font-size": "15px",
            color: "#000"
          }
        },
        lineWidth: 2,
        lineColor: "#EBEBEB"
      },
      xAxis: {
        gridLineWidth: 2,
        gridLineColor: "#EBEBEB",
        lineWidth: 2,
        lineColor: "#EBEBEB",
        tickLength: 0,
        tickInterval: 1,
        labels: {
          style: {
            "font-family":
              "GestaCond-Bold, 'GestaCond-Bold', Tahoma, Arial, sans-serif;",
            "font-size": "15px",
            color: "#000"
          }
        }
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: "none",
            format:
              "<span style=\"font-family: GestaCond-Regular, 'GestaCond-Regular', Tahoma, Arial, sans-serif; font-size: 13px;\">{point.name}</span>",
            style: {
              "font-size": "13px",
              color: "#000"
            }
          },
          groupPadding: 0.08,
          pointPadding: 0.03,
          events: {
            legendItemClick: function() {
              return false;
            }
          }
        }
      },
      legend: {
        align: "right",
        borderRadius: 0,
        borderColor: "#bfe5f0",
        borderWidth: 2,
        verticalAlign: "top",
        layout: "vertical",
        useHTML: false,
        width: 150,
        backgroundColor: {
          linearGradient: { x1: 0, x2: 0, y0: 0, y1: 1 },
          stops: [[0, "#FFF"], [1, "#e9f6fa"]]
        },
        itemStyle: {
          "font-family":
            "GestaCond-Bold, 'GestaCond-Bold', Tahoma, Arial, sans-serif;",
          "font-size": "15px",
          color: "#000",
          cursor: "default"
        },
        labelFormatter: function() {
          var tooltip;

          tooltip = ns.Config.defaultHighchartsConfig.legend.labelFormatterHelper(
            this.name
          );
          return tooltip;
        },
        /**
         * This helper exists to help calculate legends by highcharts and by our app.
         */
        labelFormatterHelper: function(name) {
          var words, charsPerLine, str, charCount, i, tooltip;

          words = name.split(/[\s]+/);
          charsPerLine = 16;
          str = [];
          charCount = words[0] ? words[0].length : 0;
          str.push(words[0]);

          for (i = 1; i < words.length; i++) {
            charCount = charCount + words[i].length;

            if (charCount >= charsPerLine) {
              str.push("</span><br/><span>");
              charCount = words[i].length;
            }
            str.push(words[i]);
          }

          tooltip = "<span>" + str.join(" ") + "</span>";

          return tooltip;
        },
        reversed: true
      },
      tooltip: {
        headerFormat: "",
        pointFormat:
          "<span style=\"font-family: GestaCond-Bold, 'GestaCond-Bold', Tahoma, Arial, sans-serif; font-size: 16px;\">{series.name}: </span><span style=\"font-family: GestaCond-Regular, 'GestaCond-Regular', Tahoma, Arial, sans-serif; font-size: 16px;\">{point.name}</span>",
        followPointer: true,
        borderWidth: 3,
        borderColor: "#000",
        backgroundColor: "rgba(255,255,255,1)",
        borderRadius: 8
      }
    }
  };

  ns.SingleCharacteristicConfig = {
    legend: {
      enabled: false
    },
    xAxis: {
      gridLineWidth: 0
    },
    plotOptions: {
      bar: {
        groupPadding: 0,
        pointPadding: 0.05
      }
    }
  };
})();
